import DashboardFinance from '../organisms/DashboardFinance';
import { TitlePart, WithErrorBoundary } from '@bloomays-lib/ui.shared';
import Box from '@mui/material/Box';

const Finance = () => {
  return (
    <div>
      <TitlePart id="financeTitle" textTitle={'Les finances de Bloomays'} />
      <Box
        sx={{
          width: '90%',
          margin: '4em auto',
        }}
      >
        <DashboardFinance />
      </Box>
    </div>
  );
};

export default WithErrorBoundary(Finance);
